/**
 * 社会服务路由模块
 * 包含服务搜索和机构详情页面
 */

const children = [
  {
    path: 'search',
    name: 'service_search',
    url: '/service/search',
    meta: { title: '服务搜索', requiresAuth: false },
    component: () => import(/* webpackChunkName: "service" */ '@/views/service/search.vue')
  },
  {
    path: 'detail/:id',
    name: 'service_detail',
    url: '/service/detail',
    meta: { title: '机构详情', requiresAuth: false },
    component: () => import(/* webpackChunkName: "service" */ '@/views/service/detail.vue')
  }
];

export default {
  path: '/service-center',
  name: 'serviceCenter',
  meta: { title: '社会服务' },
  component: () => import('@/layout/user.vue'),
  children: children
};
